var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFile(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.9425 2.94252C11.6575 2.65752 11.275 2.5 10.8775 2.5H5.5C4.675 2.5 4 3.175 4 4V16C4 16.825 4.66749 17.5 5.49249 17.5H14.5C15.325 17.5 16 16.825 16 16V7.62251C16 7.22501 15.8425 6.84249 15.5575 6.56499L11.9425 2.94252ZM12.25 14.5H7.75C7.3375 14.5 7 14.1625 7 13.75C7 13.3375 7.3375 13 7.75 13H12.25C12.6625 13 13 13.3375 13 13.75C13 14.1625 12.6625 14.5 12.25 14.5ZM12.25 11.5H7.75C7.3375 11.5 7 11.1625 7 10.75C7 10.3375 7.3375 10 7.75 10H12.25C12.6625 10 13 10.3375 13 10.75C13 11.1625 12.6625 11.5 12.25 11.5ZM10.75 7V3.625L14.875 7.75H11.5C11.0875 7.75 10.75 7.4125 10.75 7Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.257ed4e035f5fc30785f1ed84e725324.svg";
export { ForwardRef as ReactComponent };